import fetch from '@/common/axios/fetch.js'
const LOGIN = `Login/`

/**
 * 账号密码登录
 * @param {*} username 用户名
 * @param {*} password 密码
 */
export function passwordLogin(params) {
	return fetch({
		url: `${LOGIN}codeLogin`,
		data: params,
		method: 'post'
	})
}

/**
 * 验证码登录
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 */
export function codeLogin(params) {
	return fetch({
		url: `${LOGIN}codeLogin`,
		data: params,
		method: 'post'
	})
}


/**
 * 设置密码
 * @param {*} password 设置的密码
 * @param {*} mobile 手机号（没有时，可以不传）
 */
export function setPassword(password, mobile) {
	return fetch({
		url: `${LOGIN}setPassword`,
		data: {
			password,
			mobile
		},
		method: 'post'
	})
}

/**
 * 绑定手机
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 */
export function bindMobile(mobile, code) {
	return fetch({
		url: `${LOGIN}bindMobile`,
		data: {
			mobile,
			code
		},
		method: 'post'
	})
}

/**
 * 发送验证码
 * @param {*} mobile 手机号
 * @param {*} type 发送类型 0，登录；1，找回密码；2，绑定手机号；3，设置密码；4，更换手机号
 */
export function sendCode(mobile, type) {
	return fetch({
		url: `${LOGIN}sendCode`,
		data: {
			mobile,
			type
		},
		method: 'post'
	})

}

/**
 * 通过手机号找回密码的第一步，验证手机号是否存在
 * @param {*} mobile 手机号
 */
export function checkMobile(mobile, type) {
	return fetch({
		url: `${LOGIN}checkMobile`,
		data: {
			mobile
		},
		method: 'post'
	})

}

/**
 * 通过手机号找回密码的第一步，验证手机号是否存在
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 * @param {*} password 新密码
 */
export function findPassword(mobile, code, password) {
	return fetch({
		url: `${LOGIN}findPassword`,
		data: {
			mobile,
			code,
			password
		},
		method: 'post'
	})
}

/**
 * 获取用户协议
 */
export function getUserProtocol() {
	return fetch({
		method: 'get',
		url: `${LOGIN}getUserProtocol`
	})
}

/**
 * 获取隐私政策
 */
export function getPrivacyPolicy() {
	return fetch({
		method: 'get',
		url: `${LOGIN}getPrivacyPolicy`,
		skipErrorToast: true // 跳过错误提示，因为 API 可能还未配置
	}).catch(err => {
		// 如果是 404，返回一个 rejected promise，但不显示错误
		// 页面会使用默认内容
		return Promise.reject(err)
	})
}

/**
 * 微信公众号手机绑定
 */
export function weixinBindPhone(mobile, code, password) {
	return fetch({
		url: `Novelweixin/weixinBindPhone`,
		method: 'get',
		params: {
			mobile,
			code,
			password
		}
	})
}

/**
 * 微信公众号找回密码
 */
export function weixinFindPwdBind(mobile, code, password) {
	return fetch({
		url: `Novelweixin/weixinFindPwdBind`,
		method: 'get',
		params: {
			mobile,
			code,
			password
		}
	})
}

/**
 * 获取图片验证码链接
 */
export function getCaptcha() {
	let timestamp = new Date().getTime()
	return fetch({
		method: 'get',
		responseType: 'arraybuffer',
		url: `${LOGIN}getCaptcha?${timestamp}`
	})
}

/**
 * 获取图片验证码链接
 */
export function register(mobile, smscode,code, password, re_password) {
	return fetch({
		url: `${LOGIN}register`,
		method: 'get',
		params: {
			mobile,
			smscode,
			code,
			password,
			re_password
		}
	})
}

/**
 * 微信签名
 */
export function getSign(url, state) {
	return fetch({
		url: `novelweixin/getSign`,
		method: 'get',
		params: {
			url,
			state
		}
	})
}



// WEBPACK FOOTER //
// ./src/common/api/login.js